import {memo, useCallback, useEffect, useMemo, useState} from "react";
import {Sankey} from "@ant-design/charts";
import '../Styles/AmountSuffix.css'
import {Select} from "antd";


const { Option } = Select;

const SanKey = memo(({data, source = 'source', target = 'target', weight = 'value'}) => {

    const [filter, setFilter] = useState([]);

    const selectableFilter = useMemo(() => {
        return [...new Set(data.map((e) => e?.[target]))]
    }, [data, target]);

    const updateFilterValue = useCallback((value) => {
        // console.log(value);
        setFilter(value);
    }, [setFilter]);

    const filteredValue = useMemo(() => {
        return data.filter((e) => {
            return filter.includes(e?.[target]);
        })
    }, [data, filter, target]);

    useEffect(() => {
        updateFilterValue(selectableFilter);
    }, [])

    let config = {
        data: filteredValue,
        sourceField: source,
        targetField: target,
        weightField: weight,
        // nodeWidthRatio: 0.006,
        // nodePaddingRatio: 0.01,
        nodeDraggable: true
    };

    return (
        <>
            <Sankey {...config} height={1000} style={{ height: '600px' }} className={'suffix'} />
            <Select
                mode="multiple"
                allowClear
                style={{ width: '100%', marginTop: '24px' }}
                placeholder="โปรดเลือกข้อมูลที่ต้องการแสดงผล"
                defaultValue={selectableFilter}
                onChange={updateFilterValue}
            >
                { selectableFilter?.map(filter => <>
                    <Option value={filter}>{filter}</Option>
                </>) }
            </Select>
        </>
    )
})

export default SanKey;